module.exports = __webpack_public_path__ + "static/schedule_inspection-cd125c21a5c6b09f866a29a55b7a5037.gif";